import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/personal'
const api = createApi(baseUrl)

// 用户相关API
export const articleGenerationPersonalApi = {
    articleTitle: api('article_title', 'post'), //ai生成文章标题
    articleDescribe: api('article_describe', 'post'), //ai生成文章内容
}